import axios from './axios';

export const getProfile = async () => {
  return await axios.get('/api/v1/profile');
};

export const updateProfile = async (formData) => {
  // Use multipart/form-data for potential avatar upload
  return await axios.post('/api/v1/profile', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    // We override PUT using _method if Laravel requires it, or just use PUT
    // Actually, in Laravel, PUT requests don't natively support multipart/form-data file uploads!
    // Oh, this is a CRITICAL Laravel quirk!
    // To upload a file using PUT in Laravel, we must send a POST request with `_method: 'PUT'` in the fields!
    // Let's implement this standard Laravel workaround perfectly!
  });
};

export const updatePassword = async (data) => {
  return await axios.put('/api/v1/profile/update-password', data);
};

export const getRecentActivities = async () => {
  return await axios.get('/api/v1/profile/activities');
};

export const updateEmail = async (data) => {
  return await axios.post('/api/v1/profile/update-email', data);
};
